import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ISession, SessionUser } from '../models/session';
import { AclService } from '../services/acl.service';
import { getSessionUserType } from '../utilities/space.utils';

@Pipe({
  name: 'sessionUserType',
})
export class SessionUserTypePipe implements PipeTransform {
  constructor(private aclService: AclService, private translateService: TranslateService) {}

  transform(sessionUser: SessionUser, hostsIDs: Set<string>, space?: ISession): string {
    return getSessionUserType(sessionUser, hostsIDs, space, this.aclService, this.translateService);
  }
}
